import * as React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import ReactEcharts from "echarts-for-react";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { CytoListType } from './models'
import { COLOR_DARK } from './theme'
import { Box } from '@mui/material';

export interface CytokineDialogProps {
  open: boolean;
  clickedCytokines: CytoListType[];
  onClose: (value: CytoListType[]) => void;
}

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function StyledDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export function CytokineDialog(props: CytokineDialogProps) {
  const { onClose, clickedCytokines, open } = props;

  const handleClose = () => {
    onClose(clickedCytokines);
  };

  const option = {
    textStyle: {
      fontFamily: 'Lato',
      fontSize: '.9rem',
      color: COLOR_DARK
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      },
      formatter: function (params: any) {
        let tar = params[0] !== '-' ? params[0] : params[1];
        return `${tar.value.toFixed(2)}%`;
      }
    },
    grid: {
      top: 0,
      left: '0',
      right: '3%',
      bottom: '17px',
      containLabel: true,
    },
    yAxis: {
      type: 'category',
      data: clickedCytokines.sort((a, b) => a.score - b.score).map(v => v.cytokine),
      axisTick: { alignWithLabel: true, },
      axisLabel: { interval: 0, }
    },
    xAxis: {
      type: 'value',
      name: 'Drug Efficacy',
      nameLocation: "middle",
      nameTextStyle: { verticalAlign: "top", padding: 8 },
    },
    series: [
      {
        name: 'Targets all Cytokines',
        stack: 'Total',
        type: 'bar',
        color: COLOR_DARK,
        data: clickedCytokines.sort((a, b) => a.score - b.score).map(v => v.score),
      },
    ]
  };


  return (
    <Dialog onClose={handleClose} open={open} PaperProps={{ sx: { width: "100%" } }} >
      <StyledDialogTitle id="customized-dialog-title" onClose={handleClose}>Efficacy of Targeted Cytokines</StyledDialogTitle>
      <Box sx={{ m: 4, mt: 2 }}>
        <ReactEcharts option={option} />
      </Box>
    </Dialog>
  );
}
